"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CashbackText = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Displays info about cashback. Should be clickable to open a Dialog.
 * Does not render if `title` has falsy value.
 */
const CashbackText = ({
  title,
  className,
  onClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (title == null || title === '') {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.CASHBACK_TEXT),
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Wallet, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextContent, {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Arrow, {})]
  });
};
exports.CashbackText = CashbackText;
//# sourceMappingURL=CashbackText.js.map